import { fetchPost } from "../../../../../../../../../common/util/fetch";
import { UserForRanking } from "../../../../../../../../shared/User/types";

export async function fetchUsersForRanking(
    userIds: number[]
): Promise<UserForRanking[]> {
    if (userIds.length === 0) {
        return [];
    }

    const usersForRanking = await fetchPost<number[], UserForRanking[]>(
        "api/User/GetUsersForRankingFromIds",
        userIds
    );

    if ("error" in usersForRanking) {
        return [];
    }
    return usersForRanking;
}
